import firebase from 'firebase'
import User from "./user.model";
import { AppService } from '../app.service';
import { UUID } from '../../util/prototypes';
import { CustomClass } from './custom-class.model'


export class GridItem {
    constructor(payload) {
        if (payload) {
            this.gridName = payload.gridName;
            this.colStart = payload.colStart;
            this.colEnd = payload.colEnd;
            this.rowStart = payload.rowStart;
            this.rowEnd = payload.rowEnd;
            this.index = payload.index;
            this.name = `${this.gridName}__item${this.index}`;
        } else {
            this.gridName = '';
            this.colStart = 1;
            this.colEnd = 2;
            this.rowStart = 1;
            this.rowEnd = 2;
            this.index = 1;
            this.name = '';

        }
    }

    toJson(){
        return {
            ...this
        }
    }

    get style() {
        return `.${this.name}{
            grid-column-start: ${this.colStart + 1};
            grid-column-end:${this.colEnd + 1};
            grid-row-start:${this.rowStart + 1};
            grid-row-end:${this.rowEnd + 1};
        }`;
    }
}

export class Grid extends CustomClass {
    constructor(payload) {
        super(payload);
        if (payload) {
            this.rowGap = payload.rowGap;
            this.colGap = payload.colGap;
            this.rows = payload.rows;
            this.cols = payload.cols;
            this.name = `grid-${this.rows}-${this.cols}`;
        } else {
            this.rowGap = 4;
            this.colGap = 4;
            this.cols = 4;
            this.rows = 4;
        }
        this.items = this.createItems();
    }

    set(payload) {
        Object.assign(this, payload);
    }

    toJson() {
        const obj = {
            ...this,
            items: this.items.map((item)=> item.toJson()),
            user:this.user.toJson()
        };
        delete obj['doc']
        return obj;
    }

    createItems() {
        const items = [];
        for (let i = 0; i < +this.rows; i++) {
            for (let j = 0; j < +this.cols; j++) {
                items.push(new GridItem({
                    gridName: this.name,
                    colStart: j,
                    colEnd: j + 1,
                    rowStart: i,
                    rowEnd: i + 1,
                    index: i + '-' + j
                }))
            }
        }
        return items;
    }

    find(name) {
        return this.items.find((item) => item.name === name);
    }

    get style() {
        const css = `.${this.name}{
            display: grid;
            grid-template-rows: repeat(${this.rows}, 1fr);
            grid-template-columns: repeat(${this.cols}, 1fr);
            grid-gap: ${this.rowGap}px ${this.colGap}px;
        }
        ${this.items.map((item) => item.style).join('')}
        `;
        console.log(this);
        return css;
    }

    get layoutStyle() {
        return `.grid-${this.cols}-${this.rows}{`
    }

    static list(callback) {
        AppService.allGridsOnChange((snapshot) => {
            this.snapshot = snapshot;
            const list = [];
            snapshot.docs.forEach((item) => {
                const data = item.data();
                list.push(new Grid({ ...data, doc: item }))
            })
            callback(list);
        });
    }

    static loadGridsToDom(callback) {
        const stylsheet = document.createElement("style");
        stylsheet.setAttribute("type", "text/css");
        stylsheet.setAttribute("id", "gridcss");
        Grid.list((item) => {
            const css = item.map((grad) => grad.style).join(' ');
            stylsheet.innerText = css;
            document.querySelector("head").appendChild(stylsheet);
            callback(item);
        })
    }

    async create() {
        try {
            const data = {
                ...this.toJson(),
                name: `grid-${this.name.toLowerCase()}`,
                timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                uid: this.user.uid,
            };
            debugger
            const resp = await AppService.addGrid(data);
            this.doc = resp;
            return this;
        } catch (error) {
            console.error("Error in Grid.create", error);
            throw error;
        }
    }
}
